// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface ContentNoteIconSignature {
  Element: SVGSVGElement;
}

export const ContentNoteIcon: TOC<ContentNoteIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M19 3.00101H5C3.896 3.00101 3 3.89901 3 5.00101V19.001C3 20.104 3.896 21.001 5 21.001H12C12.819 21.001 13.835 20.581 14.414 20.001L20 14.416C20.58 13.836 21 12.821 21 12.002V5.00201C21 3.89901 20.104 3.00101 19 3.00101ZM5 19.001V5.00101H19V12.001H15C13.346 12.001 12 13.347 12 15.001V19.001H5ZM14 15.001V17.587L17.586 14.001H15C14.449 14.001 14 14.449 14 15.001Z"/>
</svg>
</template>;